export const notificacoes = {
  bell: 'Notifications',
  title: 'Notifications',
  empty: 'No notifications yet.',
  error: 'Could not load notifications.',
  kind: {
    atribuido: 'New content assigned',
    prazo_7d: 'Due in 7 days',
    prazo_1d: 'Due tomorrow',
    concluido: 'Completed',
  },
  vence: 'due on {{data}}',
} as const;
